import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdMessage, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked, MdWhatsapp } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE_PHONE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INTRO_1,
  STR_INTRO_2,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_WELCOME
} from "../Strings";
import logo from "../assets/logo.png";
import logo_worded_only2 from "../assets/logo_worded_only2.png";
import logo_worded_only from "../assets/logo_worded_only.png";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("launch");

  async function init() {
    //..
  }

  async function getStarted() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }
  

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div
      className="Login"
    >
      {
        (loginStep === 'launch') ?
          <div
            className="launch mNoScrollBar"
          >

            <div className="container">

              <div className="row">
                
                
                <div
                  className="col-md-6 text-center"
                  style={{
                    paddingTop: "70px",
                    
                  }}
                >

                  <div
                    className="text-center"
                    style={{
                      maxWidth: "300px",
                      margin: "0 auto",
                      height: "50px"
                    }}
                  >
                    {/*Just empty to complment the design*/}
                  </div>

                </div>

                <div
                  className="col-md-6"
                  style={{
                    paddingTop: "180px"
                  }}
                >
                  <div className="text-center">
                    <img
                      src={logo_worded_only2}
                      width="200px"
                      height="auto"
                      style={{
                        marginBottom: "100px"
                      }}
                    />
                  </div>

                  <div className="card">
                    <div className="card-body">
                      
                      
                      

                      <h6
                        style={{
                          fontSize: "20px",
                        }}
                        className="font-regular mb-4 mt-4 text-center"
                      >
                        {STR_INTRO_2[appContext.language]}
                      </h6>

                      <div className="row" style={{ marginTop: "50px", marginBottom: "20px", }}>
                        <div className="col-6">
                          <button
                            className="btn btn-padded btn-block btn-primary btn-rounded"
                            style={{
                              textTransform: "capitalize",
                              fontSize: "14px",
                            }}
                            onClick={() => getStarted()}
                          >
                            {STR_GET_STARTED[appContext.language]}
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            className="btn btn-padded btn-block bg-background btn-rounded"
                            style={{
                              textTransform: "capitalize",
                              fontSize: "14px",
                            }}
                            onClick={() => appContext.changeLanguage()}
                          >
                            {(appContext.language === 'en') ? "Use Swahili" : "Use English"}
                          </button>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
                
              </div>
            </div>

          </div>
          : ""
      }


    </div >
  )
}